import {
  dateFormatter, getLegalEntityName, localeFormatter, smevCheckWithContentFormatter, vehiclesStatusFormatter,
} from '../../../utils/formatters';

export const vehicleColumns = [
  {
    dataField: 'number',
    text: 'Номер записи',
    headerClassName: 'registry-number-column',
    formatter: (a, item) => smevCheckWithContentFormatter(a || 'Номер не указан', item?.checks_status || '', item?.federal_law_number),
  },
  {
    dataField: 'created_at',
    text: 'Дата внесения записи',
    headerClassName: 'registry-date-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'commercial_name',
    text: 'Владелец',
    headerClassName: 'registry-commercial-name-column',
    formatter: (_, a) => getLegalEntityName(a),
    sortField: 'full_name',
  },
  {
    dataField: 'inn',
    text: 'ИНН',
    headerClassName: 'registry-inn-column',
  },
  {
    dataField: 'ogrn',
    text: 'ОГРН/ОГРНИП',
    headerClassName: 'registry-ogrn-column',
  },
  {
    dataField: 'status',
    text: 'Статус',
    headerClassName: 'registry-status-column',
    formatter: a => vehiclesStatusFormatter(a),
  },
  {
    dataField: 'vehicle_brand',
    text: 'Марка ТС',
    headerClassName: 'registry-vehicle-brand-column',
  },
  {
    dataField: 'vehicle_model',
    text: 'Модель ТС',
    headerClassName: 'registry-vehicle-model-column',
  },
  {
    dataField: 'vehicle_color',
    text: 'Цвет ТС',
    headerClassName: 'registry-vehicle-color-column',
  },
  {
    dataField: 'vehicle_lpn',
    text: 'ГРН ТС',
    headerClassName: 'registry-vehicle-lpn-column',

  },
];

export const additionalVehicleColumns = [
  {
    dataField: 'legal_entity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('user.type', a),
  },
  {
    dataField: 'last_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'first_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'middle_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'birth_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'gender',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('gender', a),
  },
  {
    dataField: 'citizenship',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('citizenship.type', a),
  },
  {
    dataField: 'registration_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('registration.type', a),
  },
  {
    dataField: 'place_of_birth',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'snils',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'phone',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'email',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('identity.type', a),
  },
  {
    dataField: 'identity_series',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_issue_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'identity_issuer',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'short_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'full_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'legal_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'vehicle_year',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'vehicle_vin',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'ecology_class',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'vehicle_registration_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'vehicle_registration_issue_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'has_special_lifting_device',
    headerClassName: 'additional-column',
    formatter: a => (a ? 'Есть' : 'Нет'),
  },
  {
    dataField: 'technical_control_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'ownership_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('ownership.type', a),
  },
  {
    dataField: 'ownership_contract_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'ownership_contract_effective_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'ownership_contract_expiration_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'effective_date',
    headerClassName: 'effective-date',
    formatter: dateFormatter,
  },
  {
    dataField: 'insurer',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'insurance_contract_series',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'insurance_contract_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'insurance_contract_effective_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'insurance_contract_expiration_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'decision',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'decision_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
];
